module.exports = __webpack_public_path__ + "static/media/Glitch-4.ba641aeb.webp";